/* globals
    Control,
    Debug,
    ServerFormater,
    XmlElement,
    DATA_STATE_CLEAN,
    DATA_STATE_DIRTY
*/
/* eslint-disable new-cap, camelcase */
function ActivityObjective (
    Identifier,
    ProgressStatus,
    SatisfiedStatus,
    MeasureStatus,
    NormalizedMeasure,
    Primary,
    PrevProgressStatus,
    PrevSatisfiedStatus,
    PrevMeasureStatus,
    PrevNormalizedMeasure,
    FirstSuccessTimestampUtc,
    FirstNormalizedMeasure,
    ScoreRaw,
    ScoreMin,
    ScoreMax,
    CompletionStatus,
    CompletionStatusValue,
    ProgressMeasureStatus,
    ProgressMeasure
) {
    this.Identifier = Identifier;
    this.ProgressStatus = ProgressStatus;
    this.SatisfiedStatus = SatisfiedStatus;
    this.MeasureStatus = MeasureStatus;
    this.NormalizedMeasure = NormalizedMeasure;
    this.Primary = Primary;

    this.PrevProgressStatus = PrevProgressStatus;
    this.PrevSatisfiedStatus = PrevSatisfiedStatus;
    this.PrevMeasureStatus = PrevMeasureStatus;
    this.PrevNormalizedMeasure = PrevNormalizedMeasure;

    this.FirstSuccessTimestampUtc = FirstSuccessTimestampUtc;
    this.FirstNormalizedMeasure = FirstNormalizedMeasure;

    this.ScoreRaw = ScoreRaw;
    this.ScoreMin = ScoreMin;
    this.ScoreMax = ScoreMax;

    this.CompletionStatus = CompletionStatus;
    this.CompletionStatusValue = CompletionStatusValue;
    this.ProgressMeasureStatus = ProgressMeasureStatus;
    this.ProgressMeasure = ProgressMeasure;

    // initialize with these deafults since we need to simulate a primary objective
    // but we don't insert one into the static data
    this.SatisfiedByMeasure = false;
    this.MinNormalizedMeasure = 1.0;

    this.Maps = [];

    this.DataState = DATA_STATE_CLEAN;

    this.Sequencer = null;
}

/* eslint-disable no-use-before-define */
ActivityObjective.prototype.GetXml = ActivityObjective_GetXml;
ActivityObjective.prototype.toString = ActivityObjective_toString;
ActivityObjective.prototype.ResetAttemptState = ActivityObjective_ResetAttemptState;
ActivityObjective.prototype.GetContributesToRollup = ActivityObjective_GetContributesToRollup;
ActivityObjective.prototype.GetMeasureStatus = ActivityObjective_GetMeasureStatus;
ActivityObjective.prototype.GetNormalizedMeasure = ActivityObjective_GetNormalizedMeasure;
ActivityObjective.prototype.SetMeasureStatus = ActivityObjective_SetMeasureStatus;
ActivityObjective.prototype.SetNormalizedMeasure = ActivityObjective_SetNormalizedMeasure;
ActivityObjective.prototype.SetProgressStatus = ActivityObjective_SetProgressStatus;
ActivityObjective.prototype.SetSatisfiedStatus = ActivityObjective_SetSatisfiedStatus;
ActivityObjective.prototype.GetSatisfiedByMeasure = ActivityObjective_GetSatisfiedByMeasure;
ActivityObjective.prototype.GetMinimumSatisfiedNormalizedMeasure = ActivityObjective_GetMinimumSatisfiedNormalizedMeasure;
ActivityObjective.prototype.GetProgressStatus = ActivityObjective_GetProgressStatus;
ActivityObjective.prototype.GetSatisfiedStatus = ActivityObjective_GetSatisfiedStatus;
ActivityObjective.prototype.GetScoreRaw = ActivityObjective_GetScoreRaw;
ActivityObjective.prototype.GetScoreMin = ActivityObjective_GetScoreMin;
ActivityObjective.prototype.GetScoreMax = ActivityObjective_GetScoreMax;
ActivityObjective.prototype.GetCompletionStatus = ActivityObjective_GetCompletionStatus;
ActivityObjective.prototype.GetCompletionStatusValue = ActivityObjective_GetCompletionStatusValue;
ActivityObjective.prototype.GetProgressMeasureStatus = ActivityObjective_GetProgressMeasureStatus;
ActivityObjective.prototype.GetProgressMeasure = ActivityObjective_GetProgressMeasure;
ActivityObjective.prototype.SetScoreRaw = ActivityObjective_SetScoreRaw;
ActivityObjective.prototype.SetScoreMin = ActivityObjective_SetScoreMin;
ActivityObjective.prototype.SetScoreMax = ActivityObjective_SetScoreMax;
ActivityObjective.prototype.SetCompletionStatus = ActivityObjective_SetCompletionStatus;
ActivityObjective.prototype.SetCompletionStatusValue = ActivityObjective_SetCompletionStatusValue;
ActivityObjective.prototype.SetProgressMeasureStatus = ActivityObjective_SetProgressMeasureStatus;
ActivityObjective.prototype.SetProgressMeasure = ActivityObjective_SetProgressMeasure;
ActivityObjective.prototype.GetIdentifier = ActivityObjective_GetIdentifier;
ActivityObjective.prototype.GetMaps = ActivityObjective_GetMaps;
ActivityObjective.prototype.SetDirtyData = ActivityObjective_SetDirtyData;
ActivityObjective.prototype.SetSequencer = ActivityObjective_SetSequencer;
ActivityObjective.prototype.Clone = ActivityObjective_Clone;
ActivityObjective.prototype.TearDown = ActivityObjective_TearDown;
ActivityObjective.prototype.GetSuccessStatusChangedDuringRuntime = ActivityObjective_GetSuccessStatusChangedDuringRuntime;
/* eslint-enable no-use-before-define */

function ActivityObjective_GetXml (activityId, index) {
    var ServerFormat = new ServerFormater(),
        xml = new XmlElement("AO");

    xml.AddAttribute("AI", activityId);
    xml.AddAttribute("AOI", index);
    xml.AddAttribute("I", this.Identifier);
    xml.AddAttribute("PS", ServerFormat.ConvertBoolean(this.ProgressStatus));
    xml.AddAttribute("SS", ServerFormat.ConvertBoolean(this.SatisfiedStatus));
    xml.AddAttribute("MS", ServerFormat.ConvertBoolean(this.MeasureStatus));
    xml.AddAttribute("NM", this.NormalizedMeasure);
    xml.AddAttribute("PPS", ServerFormat.ConvertBoolean(this.PrevProgressStatus));
    xml.AddAttribute("PSS", ServerFormat.ConvertBoolean(this.PrevSatisfiedStatus));
    xml.AddAttribute("PMS", ServerFormat.ConvertBoolean(this.PrevMeasureStatus));
    xml.AddAttribute("PNM", this.PrevNormalizedMeasure);

    if (this.FirstSuccessTimestampUtc !== null) {
        xml.AddAttribute("FSTU", this.FirstSuccessTimestampUtc);
    }

    if (this.FirstNormalizedMeasure !== null) {
        xml.AddAttribute("FNM", this.FirstNormalizedMeasure);
    }

    xml.AddAttribute("P", ServerFormat.ConvertBoolean(this.Primary));
    xml.AddAttribute("CS", ServerFormat.ConvertBoolean(this.CompletionStatus));
    xml.AddAttribute("CSV", ServerFormat.ConvertBoolean(this.CompletionStatusValue));

    if (this.ScoreRaw !== null) {
        xml.AddAttribute("SR", this.ScoreRaw);
    }
    if (this.ScoreMax !== null) {
        xml.AddAttribute("SM", this.ScoreMax);
    }
    if (this.ScoreMin !== null) {
        xml.AddAttribute("SMi", this.ScoreMin);
    }

    xml.AddAttribute("PrMS", ServerFormat.ConvertBoolean(this.ProgressMeasureStatus));
    if (this.ProgressMeasure !== null) {
        xml.AddAttribute("PM", this.ProgressMeasure);
    }

    return xml.toString();
}

function ActivityObjective_toString () {
    return this.Identifier;
}

function ActivityObjective_ResetAttemptState () {
    this.PrevProgressStatus = this.ProgressStatus;
    this.PrevSatisfiedStatus = this.SatisfiedStatus;
    this.PrevMeasureStatus = this.MeasureStatus;
    this.PrevNormalizedMeasure = this.NormalizedMeasure;
    this.ProgressStatus = false;
    this.SatisfiedStatus = false;
    this.MeasureStatus = false;
    this.NormalizedMeasure = 0;
    this.ScoreRaw = null;
    this.ScoreMin = null;
    this.ScoreMax = null;
    this.CompletionStatus = false;
    this.CompletionStatusValue = false;
    this.ProgressMeasureStatus = false;
    this.ProgressMeasure = null;

    this.SetDirtyData();
}

function ActivityObjective_GetContributesToRollup () {
    return this.Primary;
}

function ActivityObjective_GetMeasureStatus (activity, canLookAtPreviousAttempt) {
    var measureStatus,
        useGlobalStatus,
        maps,
        i,
        globalObjective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetMeasureStatus");
        // canLookAtPreviousAttempt = false;
    }

    //
    // if unknown, and there is a read map, read from the global objective
    //

    //
    // when evaluating sequencing rules, if there was a previous attempt, and the current activity hasn't been
    // attempted during the current attempt on the parent, use the previous attempt's data
    //
    if (canLookAtPreviousAttempt === true
        // note use of short circuit AND (be careful that activity is always passed in)
        && typeof activity !== "undefined"
        && activity !== null
        && activity.WasAttemptedDuringThisAttempt() === false
    ) {
        measureStatus = this.PrevMeasureStatus;
    }
    else {
        measureStatus = this.MeasureStatus;
    }

    //
    // In SCORM 2004 2nd Edition, a local status overrides a global status. In 3rd Edition and later
    // the global value is always used, even if a local value is known.
    //
    useGlobalStatus = (measureStatus === false) || Control.Package.LearningStandard.is20043rdOrGreater();

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadNormalizedMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.MeasureStatus === true) {
                    measureStatus = globalObjective.MeasureStatus;
                }
            }
        }
    }

    return measureStatus;
}

function ActivityObjective_GetNormalizedMeasure (activity, canLookAtPreviousAttempt) {
    var measureStatus,
        normalizedMeasure,
        useGlobalStatus,
        maps,
        i,
        globalObjective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetNormalizedMeasure");
        // canLookAtPreviousAttempt = false;
    }

    //
    // if unknown, and there is a read map, read from the global objective
    //

    //
    // when evaluating sequencing rules, if there was a previous attempt, and the current activity hasn't been
    // attempted during the current attempt on the parent, use the previous attempt's data
    //
    if (canLookAtPreviousAttempt === true
        // note use of short circuit AND (be careful that activity is always passed in)
        && typeof activity !== "undefined"
        && activity !== null
        && activity.WasAttemptedDuringThisAttempt() === false
    ) {
        measureStatus = this.PrevMeasureStatus;
        normalizedMeasure = this.PrevNormalizedMeasure;
    }
    else {
        measureStatus = this.MeasureStatus;
        normalizedMeasure = this.NormalizedMeasure;
    }

    //
    // In SCORM 2004 2nd Edition, a local status overrides a global status. In 3rd Edition and later
    // the global value is always used, even if a local value is known.
    //
    useGlobalStatus = (measureStatus === false) || Control.Package.LearningStandard.is20043rdOrGreater();

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadNormalizedMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.MeasureStatus === true) {
                    normalizedMeasure = globalObjective.NormalizedMeasure;
                }
            }
        }
    }

    return normalizedMeasure;
}

//
// TODO: improvement - should we consolidate the reading and writing of these pairs?
//       that might simplify the global objectives code and be more logical,
//       this would also ensure that the unknown flag is always set before the data value
//       (necessary for maintaining global data properly)
//

function ActivityObjective_SetMeasureStatus (status, activity) {
    var maps,
        i,
        globalObjective;

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into SetMeasureStatus");
    }

    //
    // if not unknown, and there is a write map, write to the global objective
    //

    this.MeasureStatus = status;

    if (status === true) {
        activity.SetAttemptedDuringThisAttempt();

        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].WriteNormalizedMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective === null) {
                    this.Sequencer.AddGlobalObjective(maps[i].TargetObjectiveId, false, false, true, 0);
                }
                else {
                    globalObjective.MeasureStatus = true;
                    globalObjective.SetDirtyData();
                }
            }
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_SetNormalizedMeasure (measure, activity) {
    var maps,
        i,
        globalObjective,
        progressStatus,
        satisfiedStatus;

    //
    // if not unknown, and there is a write map, write to the global objective
    //
    this.NormalizedMeasure = measure;

    // only overwrite global data if the local data is known
    if (this.MeasureStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].WriteNormalizedMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective === null) {
                    this.Sequencer.AddGlobalObjective(maps[i].TargetObjectiveId, false, false, true, measure);
                }
                else {
                    globalObjective.NormalizedMeasure = measure;
                    globalObjective.SetDirtyData();
                }
            }
        }
    }

    //
    // if satisfied by measure is true, then the only way the objective can be satisifed is through a
    // score exceeding the mastery score, so make sure that when this happens, we set the progress and
    // success status
    //

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into SetNormalizedMeasure");
    }

    if (this.GetSatisfiedByMeasure() === true && (activity.IsActive() === false || activity.GetMeasureSatisfactionIfActive() === true)) {
        progressStatus = true;

        if (this.GetNormalizedMeasure(activity, false) >= this.GetMinimumSatisfiedNormalizedMeasure()) {
            satisfiedStatus = true;
        }
        else {
            satisfiedStatus = false;
        }

        this.SetProgressStatus(progressStatus, true, activity);
        this.SetSatisfiedStatus(satisfiedStatus, true, activity);
    }

    if (this.ProgressStatus === true && this.FirstNormalizedMeasure === 0) {
        this.FirstNormalizedMeasure = measure;
    }

    this.SetDirtyData();
}

function ActivityObjective_SetProgressStatus (status, overrideSatByMeasureCheck, activity, progressStatusChangedDuringRuntime) {
    var shouldMapToGlobals,
        maps,
        i,
        globalObjective;

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into SetMeasureStatus");
    }

    //
    // if not unknown, and there is a write map, write to the global objective
    //

    // if an objective is satisfied by measure, then it can ONLY be satisfied by measure
    if (this.GetSatisfiedByMeasure() === false || overrideSatByMeasureCheck === true) {
        this.ProgressStatus = status;

        if (status === true) {
            activity.SetAttemptedDuringThisAttempt();
        }

        // For all learning standards other than SCORM 2004 4th Edition, we should always
        // map globals if the progress status is "true"
        shouldMapToGlobals = status;

        // 4th ed change. Map Unknown to global obj as well if it was explicitly set during runtime
        if (Control.Package.LearningStandard.is20044thOrGreater()) {
            shouldMapToGlobals = shouldMapToGlobals || (progressStatusChangedDuringRuntime === true);
        }

        if (shouldMapToGlobals) {
            maps = this.Maps;

            for (i = 0; i < maps.length; i += 1) {
                if (maps[i].WriteSatisfiedStatus === true) {
                    globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                    // eslint-disable-next-line max-depth
                    if (globalObjective === null) {
                        this.Sequencer.AddGlobalObjective(maps[i].TargetObjectiveId, status, false, false, 0);
                    }
                    else {
                        globalObjective.ProgressStatus = status;
                        globalObjective.SetDirtyData();
                    }
                }
            }
        }

        this.SetDirtyData();
    }
}

function ActivityObjective_SetSatisfiedStatus (status, overrideSatByMeasureCheck, activity) {
    /* globals ConvertDateToIso8601String */
    var maps,
        i,
        globalObjective;

    //
    // if not unknown, and there is a write map, write to the global objective
    //

    // if an objective is satisfied by measure, then it can ONLY be satisfied by measure
    if (this.GetSatisfiedByMeasure() === false || overrideSatByMeasureCheck === true) {
        this.SatisfiedStatus = status;

        if (status === true && Control.Package.Properties.SatisfiedCausesCompletion === true) {
            activity.SetAttemptProgressStatus(true);
            activity.SetAttemptCompletionStatus(true);
        }

        // only overwrite global data if the local data is known
        if (this.ProgressStatus === true) {
            if (this.FirstSuccessTimestampUtc === null && status === true) {
                this.FirstSuccessTimestampUtc = ConvertDateToIso8601String(new Date());
            }

            maps = this.Maps;

            for (i = 0; i < maps.length; i += 1) {
                if (maps[i].WriteSatisfiedStatus === true) {
                    globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                    // eslint-disable-next-line max-depth
                    if (globalObjective === null) {
                        this.Sequencer.AddGlobalObjective(maps[i].TargetObjectiveId, true, status, false, 0);
                    }
                    else {
                        globalObjective.SatisfiedStatus = status;
                        globalObjective.SetDirtyData();
                    }
                }
            }
        }

        this.SetDirtyData();
    }
}

function ActivityObjective_GetSatisfiedByMeasure () {
    return this.SatisfiedByMeasure;
}

function ActivityObjective_GetMinimumSatisfiedNormalizedMeasure () {
    return parseFloat(this.MinNormalizedMeasure);
}

function ActivityObjective_GetProgressStatus (activity, canLookAtPreviousAttempt) {
    var progressStatus,
        useGlobalStatus,
        maps,
        i,
        globalObjective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetProgressStatus");
    }

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into ActivityObjective_GetProgressStatus");
    }

    //
    // if unknown, and there is a read map, read from the global objective
    // activity is passed in to help determine if we should be overriding the satisfaction status
    // using the measure value
    //

    // when evaluating sequencing rules, if there was a previous attempt, and the current activity hasn't been
    // attempted during the current attempt on the parent, use the previous attempt's data
    if (canLookAtPreviousAttempt === true && activity.WasAttemptedDuringThisAttempt() === false) {
        progressStatus = this.PrevProgressStatus;
    }
    else {
        progressStatus = this.ProgressStatus;
    }

    // In SCORM 2004 2nd Edition, a local status overrides a global status. In 3rd Edition and later
    // the global value is always used, even if a local value is known.
    useGlobalStatus = (progressStatus === false) || Control.Package.LearningStandard.is20043rdOrGreater();

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadSatisfiedStatus === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    progressStatus = globalObjective.ProgressStatus;
                }
            }
        }
    }

    //
    // if SatisfiedByMeasure && (activity.Active == false or activity.MeasureSatisfactionIfActive == true)
    // override the objective's satisfied status based on the measure value
    //
    if (this.GetSatisfiedByMeasure() === true && (activity.IsActive() === false || activity.GetMeasureSatisfactionIfActive() === true)) {
        if (this.GetMeasureStatus(activity, canLookAtPreviousAttempt) === true) {
            progressStatus = true;
        }
        else {
            progressStatus = false;
        }
    }

    return progressStatus;
}

function ActivityObjective_GetSatisfiedStatus (activity, canLookAtPreviousAttempt) {
    var satisfiedStatus,
        progressStatus,
        useGlobalStatus,
        maps,
        i,
        globalObjective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetSatisfiedStatus");
        // canLookAtPreviousAttempt = false;
    }

    //
    // if unknown, and there is a read map, read from the global objective
    // activity is passed in to help determine if we should be overriding the satisfaction status
    // using the measure value
    //

    // when evaluating sequencing rules, if there was a previous attempt, and the current activity hasn't been
    // attempted during the current attempt on the parent, use the previous attempt's data
    if (canLookAtPreviousAttempt === true && activity.WasAttemptedDuringThisAttempt() === false) {
        progressStatus = this.PrevProgressStatus;
        satisfiedStatus = this.PrevSatisfiedStatus;
    }
    else {
        progressStatus = this.ProgressStatus;
        satisfiedStatus = this.SatisfiedStatus;
    }

    // In SCORM 2004 2nd Edition, a local status overrides a global status. In 3rd Edition and later
    // the global value is always used, even if a local value is known.
    useGlobalStatus = (progressStatus === false) || Control.Package.LearningStandard.is20043rdOrGreater();

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadSatisfiedStatus === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.ProgressStatus === true) {
                    satisfiedStatus = globalObjective.SatisfiedStatus;
                }
            }
        }
    }

    // if SatisfiedByMeasure && (activity.Active == false or activity.MeasureSatisfactionIfActive == true)
    // override the objective's satisfied status based on the measure value

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into ActivityObjective_GetSatisfiedStatus");
    }
    else if (this.GetSatisfiedByMeasure() === true && (activity.IsActive() === false || activity.GetMeasureSatisfactionIfActive() === true) && this.GetMeasureStatus(activity, canLookAtPreviousAttempt) === true) {
        if (this.GetNormalizedMeasure(activity, canLookAtPreviousAttempt) >= this.GetMinimumSatisfiedNormalizedMeasure()) {
            satisfiedStatus = true;
        }
        else {
            satisfiedStatus = false;
        }
    }

    return satisfiedStatus;
}

function ActivityObjective_GetScoreRaw () {
    var returnValue = this.ScoreRaw,
        useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater(),
        maps,
        i,
        globalObjective;

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadRawScore === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.ScoreRaw !== null) {
                    returnValue = globalObjective.ScoreRaw;
                }
            }
        }
    }

    return returnValue;
}

function ActivityObjective_SetScoreRaw (scoreRaw) {
    var maps,
        i,
        globalObjective;

    this.ScoreRaw = scoreRaw;

    if (scoreRaw !== null) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].WriteRawScore === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    globalObjective.ScoreRaw = scoreRaw;
                    globalObjective.SetDirtyData();
                }
            }
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_GetScoreMin () {
    var returnValue = this.ScoreMin,
        useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater(),
        maps,
        i,
        globalObjective;

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadMinScore === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.ScoreMin !== null) {
                    returnValue = globalObjective.ScoreMin;
                }
            }
        }
    }

    return returnValue;
}

function ActivityObjective_SetScoreMin (scoreMin) {
    var maps,
        i,
        globalObjective;

    this.ScoreMin = scoreMin;

    if (scoreMin !== null) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].WriteMinScore === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    globalObjective.ScoreMin = scoreMin;
                    globalObjective.SetDirtyData();
                }
            }
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_GetScoreMax () {
    var returnValue = this.ScoreMax,
        useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater(),
        maps,
        i,
        globalObjective;

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadMaxScore === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.ScoreMax !== null) {
                    returnValue = globalObjective.ScoreMax;
                }
            }
        }
    }

    return returnValue;
}

function ActivityObjective_SetScoreMax (scoreMax) {
    var maps,
        i,
        globalObjective;

    this.ScoreMax = scoreMax;

    if (scoreMax !== null) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].WriteMaxScore === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    globalObjective.ScoreMax = scoreMax;
                    globalObjective.SetDirtyData();
                }
            }
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_GetCompletionStatus (activity, canLookAtPreviousAttempt) {
    var returnValue,
        useGlobalStatus,
        maps,
        globalObjective,
        i;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetCompletionStatus");
        // canLookAtPreviousAttempt = false;
    }

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into ActivityObjective_GetCompletionStatusValue");
    }

    returnValue = this.CompletionStatus;
    useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater();

    if (useGlobalStatus === true) {
        maps = this.Maps;
        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadCompletionStatus === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    returnValue = globalObjective.CompletionStatus;
                }
            }
        }
    }

    return returnValue;
}

function ActivityObjective_GetCompletionStatusValue (activity, canLookAtPreviousAttempt) {
    var returnValue,
        useGlobalStatus,
        maps,
        i,
        globalObjective;

    if (typeof canLookAtPreviousAttempt === "undefined" || canLookAtPreviousAttempt === null) {
        Debug.AssertError("ERROR - canLookAtPreviousAttempt must be passed into GetCompletionStatusValue");
        // canLookAtPreviousAttempt = false;
    }

    if (typeof activity === "undefined" || activity === null) {
        Debug.AssertError("ERROR - activity must be passed into ActivityObjective_GetCompletionStatusValue");
    }

    returnValue = this.CompletionStatusValue;
    useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater();

    if (useGlobalStatus === true) {
        maps = this.GetMaps("ReadCompletionStatus", true);

        for (i = 0; i < maps.length; i += 1) {
            globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

            if (globalObjective !== null) {
                returnValue = globalObjective.CompletionStatusValue;
            }
        }
    }

    return returnValue;
}

function ActivityObjective_SetCompletionStatus (completionStatus) {
    var maps,
        i,
        globalObjective;

    this.CompletionStatus = completionStatus;

    maps = this.GetMaps("WriteCompletionStatus", true);

    for (i = 0; i < maps.length; i += 1) {
        globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

        if (globalObjective !== null) {
            globalObjective.CompletionStatus = completionStatus;
            globalObjective.SetDirtyData();
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_SetCompletionStatusValue (completionStatusValue) {
    var maps,
        i,
        globalObjective;

    this.CompletionStatusValue = completionStatusValue;

    maps = this.GetMaps("WriteCompletionStatus", true);

    for (i = 0; i < maps.length; i += 1) {
        globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

        if (globalObjective !== null) {
            globalObjective.CompletionStatusValue = completionStatusValue;
            globalObjective.SetDirtyData();
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_GetProgressMeasureStatus () {
    var returnValue = this.ProgressMeasureStatus,
        useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater(),
        maps,
        i,
        globalObjective;

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadProgressMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    returnValue = globalObjective.ProgressMeasureStatus;
                }
            }
        }
    }

    return returnValue;
}

function ActivityObjective_GetProgressMeasure () {
    var returnValue = this.ProgressMeasure,
        useGlobalStatus = Control.Package.LearningStandard.is20044thOrGreater(),
        maps,
        i,
        globalObjective;

    if (useGlobalStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].ReadProgressMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null && globalObjective.ProgressMeasureStatus !== false) {
                    returnValue = globalObjective.ProgressMeasure;
                }
            }
        }
    }

    return returnValue;
}

function ActivityObjective_SetProgressMeasureStatus (progressMeasureStatus) {
    var maps,
        i,
        globalObjective;

    this.ProgressMeasureStatus = progressMeasureStatus;

    maps = this.Maps;

    for (i = 0; i < maps.length; i += 1) {
        if (maps[i].WriteProgressMeasure === true) {
            globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

            if (globalObjective !== null) {
                globalObjective.ProgressMeasureStatus = progressMeasureStatus;
                globalObjective.SetDirtyData();
            }
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_SetProgressMeasure (progressMeasure) {
    var maps,
        i,
        globalObjective;

    this.ProgressMeasure = progressMeasure;

    if (this.ProgressMeasureStatus === true) {
        maps = this.Maps;

        for (i = 0; i < maps.length; i += 1) {
            if (maps[i].WriteProgressMeasure === true) {
                globalObjective = this.Sequencer.GetGlobalObjectiveByIdentifier(maps[i].TargetObjectiveId);

                if (globalObjective !== null) {
                    globalObjective.ProgressMeasure = progressMeasure;
                    globalObjective.SetDirtyData();
                }
            }
        }
    }

    this.SetDirtyData();
}

function ActivityObjective_GetIdentifier () {
    return this.Identifier;
}

function ActivityObjective_GetMaps (mapType, mapTypeValue) {
    var maps = this.Maps,
        mapSubset,
        i;

    if (maps.length > 0 && typeof mapType !== "undefined" && mapType !== null) {
        if (typeof mapTypeValue === "undefined" && mapTypeValue === null) {
            mapTypeValue = true;
        }

        mapSubset = [];
        for (i = 0; i < maps.length; i += 1) {
            if (maps[i][mapType] === mapTypeValue) {
                mapSubset[mapSubset.length] = maps[i];
            }
        }

        return mapSubset;
    }

    return maps;
}

function ActivityObjective_SetDirtyData () {
    this.DataState = DATA_STATE_DIRTY;
}

function ActivityObjective_SetSequencer (sequencer) {
    this.Sequencer = sequencer;
}

function ActivityObjective_Clone () {
    var clone = new ActivityObjective(
        this.Identifier,
        this.ProgressStatus,
        this.SatisfiedStatus,
        this.MeasureStatus,
        this.NormalizedMeasure,
        this.Primary,
        null,
        null,
        null,
        null,
        null,
        null,
        this.ScoreRaw,
        this.ScoreMin,
        this.ScoreMax,
        this.CompletionStatus,
        this.CompletionStatusValue,
        this.ProgressMeasureStatus,
        this.ProgressMeasure
    );

    clone.SatisfiedByMeasure = this.SatisfiedByMeasure;
    clone.MinNormalizedMeasure = this.MinNormalizedMeasure;
    clone.CompletionStatusSetAtRuntime = this.CompletionStatusSetAtRuntime;
    clone.Maps = this.Maps;

    return clone;
}

function ActivityObjective_TearDown () {
    this.Identifier = null;
    this.ProgressStatus = null;
    this.SatisfiedStatus = null;
    this.MeasureStatus = null;
    this.NormalizedMeasure = null;
    this.ScoreRaw = null;
    this.ScoreMin = null;
    this.ScoreMax = null;
    this.CompletionStatus = null;
    this.CompletionStatusValue = null;
    this.ProgressMeasure = null;
    this.Primary = null;
    this.SatisfiedByMeasure = null;
    this.MinNormalizedMeasure = null;
    this.Maps = null;
    this.DataState = null;
    this.Sequencer = null;
    this.ProgressMeasureStatus = null;
    this.ProgressMeasure = null;
}

function ActivityObjective_GetSuccessStatusChangedDuringRuntime (activity) {
    var rtObjective = activity.RunTime.FindObjectiveWithId(this.Identifier);

    if (rtObjective !== null && rtObjective.SuccessStatusChangedDuringRuntime === true) {
        return true;
    }

    return false;
}
